import { render, staticRenderFns } from "./BotPlans.vue?vue&type=template&id=07653798&"
import script from "./BotPlans.vue?vue&type=script&lang=js&"
export * from "./BotPlans.vue?vue&type=script&lang=js&"
import style0 from "./BotPlans.vue?vue&type=style&index=0&id=07653798&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports